import type { trackUserClick } from '@hc-frontend/third-party-snowplow';

export function queryCategory(pathName: string): string {
  if (pathName === '/') {
    return 'landing';
  }

  return pathName.split('/')[1] as string;
}

export function queryClickDataById(
  elementId: string,
): Parameters<typeof trackUserClick>[0] | undefined {
  const catalog: Record<string, Parameters<typeof trackUserClick>[0]> = {
    'header-rx-card-banner-partner-link': {
      elementId: 'header-rx-card-banner-partner-link',
      category: 'landing',
      placement: 'rx-banner-partner-link',
      action: 'click',
      label: 'RX Banner Partner Link',
      targetUrl:
        'https://docs.google.com/forms/d/e/1FAIpQLScIGl8n782ZmR4z_FPNQI00TllPxDSiU6h1Y-DFr3aorCcn1g/viewform',
      value: 'RX Banner Partner Link',
    },
    'header-nav-bar-products-and-services-virtualcare': {
      elementId: 'header-nav-bar-products-and-services-virtualcare',
      category: 'landing',
      placement: 'header-nav-bar-products-and-services',
      action: 'click',
      label: 'Virtual Care',
      targetUrl: 'https://healthcare-com.getlyric.com/hc/plan/hcdcom',
      value: 'Virtual Care',
    },
    'header-insurance-INSX': {
      elementId: 'header-insurance-INSX',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Health Insurance',
      targetUrl: 'https://healthcare-com.insxcloud.com/get-a-quote',
      value: 'Health Insurance',
    },
    'Marketplace Plans_heropill': {
      elementId: 'Marketplace Plans_heropill',
      category: 'landing',
      placement: 'hero-section',
      action: 'click',
      label: 'Marketplace Plans',
      targetUrl: 'https://healthcare-com.insxcloud.com/get-a-quote',
      value: 'Insurance',
    },
    'Member Accounts_heropill': {
      elementId: 'Member Accounts_heropill',
      category: 'landing',
      placement: 'hero-section',
      action: 'click',
      label: 'Member Accounts',
      targetUrl: 'https://members.healthcare.com',
      value: 'Member Portal',
    },
    'header-tools-and-advice-healthcare-insider': {
      elementId: 'header-tools-and-advice-healthcare-insider',
      category: 'landing',
      placement: 'header-nav-bar-tools-and-advice',
      action: 'click',
      label: 'Healthcare Insider',
      targetUrl: 'https://healthcareinsider.com/',
      value: 'Healthcare Insider',
    },
    'header-tools-and-advice-subsidy-calc': {
      elementId: 'header-tools-and-advice-subsidy-calc',
      category: 'landing',
      placement: 'header-nav-bar-tools-and-advice',
      action: 'click',
      label: 'ACA Subsidy Calculator',
      targetUrl: 'https://healthcareinsider.com/aca-subsidy-calculator-186869',
      value: 'ACA Subsidy Calculator',
    },
    'ACA Subsidy Calculator_heropill': {
      elementId: 'ACA Subsidy Calculator_heropill',
      category: 'landing',
      placement: 'hero-section',
      action: 'click',
      label: 'ACA Subsidy Calculator',
      targetUrl: 'https://healthcareinsider.com/aca-subsidy-calculator-186869',
      value: 'Insurance',
    },
    'carousel-link-3': {
      elementId: 'carousel-link-3',
      category: 'landing',
      placement: 'carousel',
      action: 'click',
      label: 'Tools & Advice',
      targetUrl: 'https://healthcareinsider.com/use-coverage',
      value: 'Carousel Item 3',
    },
    'header-insurance-vision': {
      elementId: 'header-insurance-vision',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Vision Insurance',
      targetUrl: 'https://lensabl.pxf.io/baOz1x',
      value: 'Vision Insurance',
    },
    'header-insurance-medicare': {
      elementId: 'header-insurance-medicare',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Medicare',
      targetUrl: 'https://welcome.healthcare.com/medicare',
      value: 'Medicare',
    },
    Medicare_heropill: {
      elementId: 'Medicare_heropill',
      category: 'landing',
      placement: 'hero-section',
      action: 'click',
      label: 'Medicare',
      targetUrl: 'https://welcome.healthcare.com/medicare',
      value: 'Insurance',
    },
    'header-tools-and-advice-medicare-guide': {
      elementId: 'header-tools-and-advice-medicare-guide',
      category: 'landing',
      placement: 'header-nav-bar-tools-and-advice',
      action: 'click',
      label: 'Medicare Guide',
      targetUrl: 'https://medicareguide.com/',
      value: 'Medicare Guide',
    },
    'carousel-link-2': {
      elementId: 'carousel-link-2',
      category: 'landing',
      placement: 'carousel',
      action: 'click',
      label: 'Healthcare Pharmacy',
      targetUrl: 'https://pharmacy.healthcare.com/',
      value: 'Carousel Item 2',
    },
    'carousel-link-1': {
      elementId: 'carousel-link-1',
      category: 'landing',
      placement: 'carousel',
      action: 'click',
      label: '',
      targetUrl: 'https://quotes.healthcare.com/',
      value: 'Carousel Item 1',
    },
    'header-nav-bar-products-and-services-retirement': {
      elementId: 'header-nav-bar-products-and-services-retirement',
      category: 'landing',
      placement: 'header-nav-bar-products-and-services',
      action: 'click',
      label: 'Retirement Services',
      targetUrl:
        'https://retirable.com/welcome?utm_source=medicare&utm_medium=landing-page&utm_campaign=healthcare-dot-com&utm_term=pivot-health',
      value: 'Retirement Services',
    },
    'header-pharmacy-rx-card': {
      elementId: 'header-pharmacy-rx-card',
      category: 'landing',
      placement: 'header-nav-bar-pharmacy',
      action: 'click',
      label: 'Prescription Discount Card',
      targetUrl: 'https://rxcards.healthcare.com/',
      value: 'Prescription Discount Card',
    },
    'Short Term Insurance_heropill': {
      elementId: 'Short Term Insurance_heropill',
      category: 'landing',
      placement: 'hero-section',
      action: 'click',
      label: 'Short Term Insurance',
      targetUrl: 'https://stm.healthcare.com/',
      value: 'Insurance',
    },
    'header-nav-bar-products-and-services-store': {
      elementId: 'header-nav-bar-products-and-services-store',
      category: 'landing',
      placement: 'header-nav-bar-products-and-services',
      action: 'click',
      label: 'Healthcare Store',
      targetUrl: 'https://store.healthcare.com/',
      value: 'Healthcare Store',
    },
    'carousel-link-4': {
      elementId: 'carousel-link-4',
      category: 'landing',
      placement: 'carousel',
      action: 'click',
      label: 'Products & Services',
      targetUrl: 'https://store.healthcare.com/',
      value: 'Carousel Item 4',
    },
    'header-nav-bar-products-and-services-store-hearing': {
      elementId: 'header-nav-bar-products-and-services-store-hearing',
      category: 'landing',
      placement: 'header-nav-bar-products-and-services',
      action: 'click',
      label: 'Hearing Care',
      targetUrl:
        'https://store.healthcare.com/collections/hearing-care/products',
      value: 'Hearing Care',
    },
    'header-nav-bar-about-us': {
      elementId: 'header-nav-bar-about-us',
      category: 'landing',
      placement: 'header-nav-bar-about-us',
      action: 'click',
      label: 'About Us',
      targetUrl: 'https://www.healthcare.com/about-company',
      value: 'About Us',
    },
    'header-tools-and-advice-latest-articles': {
      elementId: 'header-tools-and-advice-latest-articles',
      category: 'landing',
      placement: 'header-nav-bar-tools-and-advice',
      action: 'click',
      label: 'Latest Articles',
      targetUrl: 'https://www.healthcare.com/analysis',
      value: 'Latest Articles',
    },
    'header-tools-and-advice-online-therapy-finder': {
      elementId: 'header-tools-and-advice-online-therapy-finder',
      category: 'landing',
      placement: 'header-nav-bar-tools-and-advice',
      action: 'click',
      label: 'Online Therapy Finder',
      targetUrl:
        'https://www.healthcare.com/mental-health-service-provider-selector',
      value: 'Online Therapy Finder',
    },
    'header-insurance-pet': {
      elementId: 'header-insurance-pet',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Pet Insurance',
      targetUrl: 'https://www.healthcare.com/pet-insurance',
      value: 'Pet Insurance',
    },
    'header-insurance-travel': {
      elementId: 'header-insurance-travel',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Travel Insurance',
      targetUrl: 'https://www.healthcare.com/travel-insurance-lp-2',
      value: 'Travel Insurance',
    },
    'header-nav-bar-products-and-services-doctor': {
      elementId: 'header-nav-bar-products-and-services-doctor',
      category: 'landing',
      placement: 'header-nav-bar-products-and-services',
      action: 'click',
      label: 'Find a Doctor',
      targetUrl: 'https://www.medifind.com/find-a-doctor?isStarted=true&step=0',
      value: 'Find a Doctor',
    },
    'header-insurance-pre-medicare': {
      elementId: 'header-insurance-pre-medicare',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Pre-Medicare',
      targetUrl: 'https://www.pivothealth.com/bridge-to-medicare',
      value: 'Pre-Medicare',
    },
    'header-insurance-dental': {
      elementId: 'header-insurance-dental',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Dental Insurance',
      targetUrl: 'https://www.pivothealth.com/dental-and-vision',
      value: 'Dental Insurance',
    },
    'header-insurance-short-term': {
      elementId: 'header-insurance-short-term',
      category: 'landing',
      placement: 'header-nav-bar-insurance',
      action: 'click',
      label: 'Short Term Medical Insurance',
      targetUrl: 'https://www.pivothealth.com/short-term-health-insurance',
      value: 'Short Term Medical Insurance',
    },
  };

  return catalog[elementId];
}
